export default function buildMakeFlowHydrantReport() {
  return function makeFlowHydrantReport({
    fireFlowTestId,
    hydrantId,
    flowHydrant,
    flowDevice,
    diameter,
    gpm,
    gallonsUsed
  }) {
    return Object.freeze({
      get fireFlowTestId() { return fireFlowTestId },
      get hydrantId() { return hydrantId },
      get flowHydrant() { return flowHydrant },
      get flowDevice() { return flowDevice },
      get diameter() { return diameter },
      get gpm() { return gpm },
      get gallonsUsed() { return gallonsUsed },
    });
  }
}